import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import {H1, Body, Label} from "@irati/ui/src/Typography"
import theme from "@irati/ui/src/global/theme"
import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import {IconTypes} from "@irati/ui/src/Icon"

import FilterChip from "../FilterChip"
import {GradientBody} from "../RenewalCard/styled"

export interface AddOns {
  icon: IconTypes
  label: string
}

interface Props extends InjectIntl {
  title: string
  body: string
  pending?: string
  showPending?: boolean
  addOns: AddOns[]
  seats?: number
  isManual?: boolean
}

const RenewalHeader: FC<Props> = ({title, body, pending, addOns, showPending, isManual = false, seats, formatMessage}) => {
  const pendingText = pending || "admin.billing.renewals.header.pending"
  const products = seats
    ? addOns.map((addOn) => {
        if (addOn.icon === "userPlus") {
          return {icon: "userPlus", label: formatMessage({id: "admin.billing.renewals.pills.users"}, {seats})}
        }
        return addOn
      })
    : addOns

  return (
    <>
      <Flex marginBottom={1} alignItems="center">
        <H1 color={theme.colors.greys.white}>
          <FormattedMessage id={title} />
        </H1>
        {showPending && (
          <GradientBody small padding={0.5} marginLeft={2}>
            <FormattedMessage id={pendingText} />
          </GradientBody>
        )}
      </Flex>
      <Body color={theme.colors.greys.mediumLight} marginBottom={3} marginRight={3}>
        <FormattedMessage id={body} />
      </Body>
      {!isManual && (
        <>
          <Label color={theme.colors.greys.mediumLight} marginBottom={1}>
            <FormattedMessage id="admin.billing.renewals.planIncludes" />
          </Label>
          <Flex wrap="wrap" gap={theme.spacing.one}>
            {products.map((data, i) => (
              <FilterChip
                key={i}
                textColor={theme.colors.primary2}
                fillColor={data?.icon === IconTypes.flexi ? theme.colors.primary2 : theme.colors.greys.white}
                icon={data?.icon}>
                {formatMessage({id: data.label})}
              </FilterChip>
            ))}
          </Flex>
        </>
      )}
    </>
  )
}

export default injectIntl(RenewalHeader)
